import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

function BirthDateFormatCustom(props) {
    const {
        inputRef,
        ...other
    } = props;
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
        />
    );
}

BirthDateFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default BirthDateFormatCustom;



// WEBPACK FOOTER //
// ./src/app/common/BirthDateFormatCustom.js